module.exports = __webpack_public_path__ + "static/media/home.020991ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home.jpg
// module id = 232
// module chunks = 0